import { ResponseBase, ParkingArea } from "@/models";
import axios from "axios";

export default class ParkingService {
    public async Reserve(accountId: number, area: string, parkingSlot: string, apartmentId: number, startFrom: Date): Promise<ResponseBase> { 
        const result = (await axios.post<ResponseBase>("parking/reserve",
        { accountId, area, parkingSlot, apartmentId, startingFrom: startFrom })).data;

        return result;
    }

    public async RemoveReservation(accountId: number, area: string, parkingSlot: string, apartmentId: number): Promise<ResponseBase> {
        const result = (await axios.post<ResponseBase>("parking/remove-reservation",
        { accountId, area, parkingSlot, apartmentId })).data;

        return result;
    }

    public async GetParkingAreas(housingCompanyId: number): Promise<ParkingArea[]> {
        const result = (await axios.get(`parking/slots`, { params: { housingCompanyId }})).data;

        return result;
    }
}
